/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Keys_EmptyInputs */

const en_settings_keys_empty = /** @type {(inputs: Settings_Keys_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No keys yet.`)
};

const id_settings_keys_empty = /** @type {(inputs: Settings_Keys_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada key.`)
};

/**
* | output |
* | --- |
* | "No keys yet." |
*
* @param {Settings_Keys_EmptyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_keys_empty = /** @type {((inputs?: Settings_Keys_EmptyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Keys_EmptyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_keys_empty(inputs)
	return en_settings_keys_empty(inputs)
});